import { Button, Image, TextChip, ChipTypes } from "@atoms";

export type PerkCardMiniTemplateProps = {
  title: string;
  isSelected: boolean;
  isAvailable: boolean;
  icon: JSX.Element;
  onClick: any;
  includedInPackage: boolean;
  isBeta?: boolean;
};

export const PerkCardMiniTemplate = ({
  title,
  isSelected,
  isAvailable,
  icon,
  onClick,
  includedInPackage,
  isBeta,
}: PerkCardMiniTemplateProps): JSX.Element => {
  return (
    <button
      onClick={onClick}
      className={`group flex flex-row w-24 h-24 bg-transparent border border-neutral-light rounded-2xl 
      border-neutral-light hover:border-primary-mediumish justify-center items-center transition ease-in-out delay-0 duration-200 transition transform scale-100 ease-in-out delay-0 duration-200 hover:scale-105
      `}
    >
      <div className="flex flex-col w-full h-auto max-w-max justify-between items-center">
        {/* {isAvailable ? (
          true ? ( //!includedInPackage ?
            <div>
              <TextChip type={ChipTypes.activated} />
            </div>
          ) : null
        ) : isBeta ? (
          <div>
            <TextChip type={ChipTypes.beta} />
          </div>
        ) : (
          <div>
            <TextChip type={ChipTypes.comingSoon} />
          </div>
        )} */}
        <div className="flex border-0 p-1 rounded-full bg-neutral-light self-center h-10 w-10 items-center justify-center duration-200">
          {icon}
        </div>
        <div className="h-full w-full">
          <div className="w-full">
            <div className="font-medium text-xs text-neutral-darkest mt-2">
              {title}
            </div>
            {/* <div className="font-normal text-sm leading-5 text-neutral-darkest">
              {text}
            </div> */}
          </div>
        </div>
      </div>
    </button>
  );
};
